import { useState, useEffect } from 'react';
import { useNotifications } from '../context/NotificationContext';
import { fmtDateTime, timeAgo } from '../utils/format';

const DOT = { ok: 'var(--ok)', danger: 'var(--danger)', warn: 'var(--warn)', info: 'var(--accent)' };

export default function NotificationBell() {
  const { items, markAllRead, clearAll, removeOne, unread, permission, enableBrowserNotifications } = useNotifications();
  const [open, setOpen] = useState(false);
  // Cập nhật "X phút trước" mỗi 30s khi đang mở danh sách.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!open) return;
    const id = setInterval(() => setTick((t) => t + 1), 30000);
    return () => clearInterval(id);
  }, [open]);

  function toggle() {
    const next = !open;
    setOpen(next);
    if (next && unread) markAllRead();
  }

  return (
    <>
      {open && <div style={{ position: 'fixed', inset: 0, zIndex: 84 }} onClick={() => setOpen(false)} />}
      <div style={{ position: 'fixed', top: 'calc(14px + env(safe-area-inset-top))', right: 18, zIndex: 86 }}>
        <button
          onClick={toggle}
          title="Thông báo"
          style={{
            position: 'relative',
            width: 40,
            height: 40,
            borderRadius: 10,
            border: '1px solid var(--border)',
            background: 'var(--panel)',
            cursor: 'pointer',
            fontSize: 18,
            boxShadow: '0 2px 6px rgba(40,60,120,.08)',
          }}
        >
          🔔
          {unread > 0 && (
            <span
              style={{
                position: 'absolute',
                top: -6,
                right: -6,
                minWidth: 18,
                height: 18,
                padding: '0 4px',
                borderRadius: 9,
                background: 'var(--danger)',
                color: '#fff',
                fontSize: 11,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {unread > 99 ? '99+' : unread}
            </span>
          )}
        </button>

        {open && (
          <div
            style={{
              position: 'absolute',
              top: 48,
              right: 0,
              width: 360,
              maxWidth: '90vw',
              maxHeight: '70vh',
              overflow: 'auto',
              background: 'var(--panel)',
              border: '1px solid var(--border)',
              borderRadius: 12,
              boxShadow: '0 16px 40px rgba(40,60,120,.18)',
            }}
          >
            <div
              className="row between"
              style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', position: 'sticky', top: 0, background: 'var(--panel)' }}
            >
              <b style={{ fontSize: 14 }}>Thông báo ({items.length})</b>
              {items.length > 0 && (
                <button className="btn ghost sm" onClick={clearAll}>
                  Xóa tất cả
                </button>
              )}
            </div>
            {permission === 'default' && (
              <div className="row between" style={{ padding: '8px 14px', borderBottom: '1px solid var(--border)', gap: 8 }}>
                <span className="small muted">Bật thông báo hiện lên màn hình Chrome?</span>
                <button className="btn sm" onClick={enableBrowserNotifications}>
                  Bật
                </button>
              </div>
            )}
            {permission === 'denied' && (
              <div className="small muted" style={{ padding: '8px 14px', borderBottom: '1px solid var(--border)' }}>
                Thông báo trình duyệt đang bị chặn. Hãy bật lại trong cài đặt site của Chrome.
              </div>
            )}
            {items.length ? (
              items.map((n) => (
                <div
                  key={n.id}
                  className="row"
                  style={{ gap: 10, padding: '10px 14px', borderBottom: '1px solid var(--border)', alignItems: 'flex-start' }}
                >
                  <span
                    style={{ width: 8, height: 8, borderRadius: '50%', background: DOT[n.type] || DOT.info, marginTop: 6, flexShrink: 0 }}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13 }}>{n.message}</div>
                    <div className="small muted" style={{ marginTop: 2 }} title={fmtDateTime(n.at)}>
                      {timeAgo(n.at)} · {fmtDateTime(n.at)}
                    </div>
                  </div>
                  <span
                    onClick={() => removeOne(n.id)}
                    title="Xóa"
                    style={{ cursor: 'pointer', color: 'var(--muted)', fontSize: 16, lineHeight: 1 }}
                  >
                    ×
                  </span>
                </div>
              ))
            ) : (
              <div className="empty">Chưa có thông báo nào.</div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
